export default "/images/d4448572c7b000cdf12a6e0d0b5a76a7.avif";